export default __webpack_public_path__ + "static/media/Omae_wa_mou_shindeiru.2ca2a250.mp3";